import { IconLayoutRows } from '@rossum/ui/icons/tabler';
import { Chip, SvgIcon } from '@rossum/ui/material';

type MultivalueChipProps = {
  childrenCount: number;
};

export const MultivalueChip = ({ childrenCount }: MultivalueChipProps) => {
  return (
    <Chip
      icon={
        <SvgIcon fontSize="medium">
          <IconLayoutRows />
        </SvgIcon>
      }
      label={childrenCount}
      sx={{ float: 'right' }}
    />
  );
};
